import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

const resource = resources.UsuarioZE;
type Entity = models.VehiculoZE;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
* Modal de edición para un VehiculoZE
*/
export class VehiculoZEEdit extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    hasError = createSelectorRx(this.errors, err => validation.hasError(err));
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            ModeloAño: validation.required
        };
    }

    onGuardar = async () => {
        this.props.value.IdUsuarioZE = localStorage['myKeyIdUsuarioZE'];
        var ccccc = await resource.GuardarVehiculoZE( this.props.value );
        if (ccccc != null ) {
            //location.reload();    
            this.props.value.IdRegistro = ccccc.IdRegistro;
            this.props.onClose(true);
        }
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        const DateTime = getField(kea.DateTime);
        const hasError = this.hasError(this.props);

        const CpSatTipoPermisoSelector = getField(selectores.CpSatTipoPermisoSelector);
        const CpSatConfigAutotransporte = getField(selectores.CpSatConfigAutotransporteSelector);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton disabled={ hasError } onClick={this.onGuardar} />]}
                onClose={this.onCerrar}
                title="Editar Vehiculo"
            >
                {kea.autogrid(6, [
                    <Text field="Marca" />,
                    <Number field="ModeloAño" />,
                    <Text field="Placas" />,
                    <Text field="VIN" />,
                    <Text field="Color" />,

                    <Text field="Aseguradora" label="Nombre de la aseguradora" />,
                    <Text field="NumeroPoliza" label="Número de la poliza del seguro" />,
                    <CpSatTipoPermisoSelector field="IdTipoPermiso" label="Tipo Permiso Sat" />,
                    <Text field="PermisoSCT" label="Número de Permiso SCT" />,
                    <CpSatConfigAutotransporte field="IdConfigAutotransporte" label="Tipo de autotransporte" />,
                    <Number field="peso" />,

                    
                ])}
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuariosze/edit/componentes/vehiculos/edit.tsx